// Recorta el relleno nativo sin cubrirlo con otro color ni desactivar autofill.
// Selectores separados para navegadores que solo reconocen uno de los dos.
const autofill = {
  backgroundClip: "text",
  WebkitBackgroundClip: "text",
  boxShadow: "none",
  WebkitBoxShadow: "none",
  WebkitTextFillColor: "var(--marca-ink)",
  caretColor: "var(--marca-ink)",
};

export const authFieldsSx = {
  "& .MuiOutlinedInput-root": { backgroundColor: "transparent" },
  "& .MuiOutlinedInput-input:autofill": autofill,
  "& .MuiOutlinedInput-input:-webkit-autofill": autofill,
};
